import { ListTextIconCol } from '@csp/csp-web-ui';
import { FC, memo } from 'react';
import { BioSampleKitType } from '@csp/csp-common-hbs-model';
import { Maybe } from '@csp/csp-common-model';
import { BioSampleBaseCol } from '../model/BioSampleBaseCol';

type Props = BioSampleBaseCol & {
  kitTypeLabel: string;
  kitType: Maybe<BioSampleKitType>;
};

export const KitTypeCol: FC<Props> = memo(({ kitTypeLabel, kitType, ...props }) => (
  <ListTextIconCol title={kitTypeLabel} text={kitType} dash {...props} />
));

KitTypeCol.displayName = 'KityTypeCol';
